import moment from "moment";
import { fireStore } from "../../../firebase";
import { WEB_ACTION } from "./actions";
import { IData } from "./common";

const DATA_COUNT = 90;
const COLLECTION_NAME = "DS1";

interface IDailySentimentData {
  index: IData[];
  sentiment: IData[];
  sentiment2: IData[];
  momentum: IData[];
  requested: boolean;
  loaded: boolean;
}

const initialState: IDailySentimentData = {
  momentum: [],
  sentiment: [],
  sentiment2: [],
  index: [],
  requested: false,
  loaded: false,
};

export function loadDailySentiment(firebase: any) {
  return async function thunk(dispatch: any, getState: any) {
    const state = getState();
    if (state.DailySentiment.requested) return;
    dispatch({
      type: WEB_ACTION.DAILY_SENTIMENT,
      payload: {
        requested: true,
      },
    });

    fireStore
      .collection(COLLECTION_NAME)
      .orderBy("dateTime", "desc")
      .limit(DATA_COUNT)
      .onSnapshot((querySnapshot: any) => {
        var sentimentData: Object[] = [];
        var sentiment2Data: Object[] = [];
        var momentumData: Object[] = [];
        var indexData: Object[] = [];
        querySnapshot.forEach(function (doc: any) {
          const dateVal = moment
            .unix(doc.data().dateTime.seconds)
            .format("YYYY/MM/DD");
          sentimentData.push({
            name: "sentiment",
            value: [dateVal, doc.data().sentiment],
            date: doc.data().dateTime.seconds,
          });
          sentiment2Data.push({
            name: "sentiment",
            value: [dateVal, doc.data().sentiment2],
            date: doc.data().dateTime.seconds,
          });
          momentumData.push({
            name: "momentum",
            value: [dateVal, doc.data().momentum],
            date: doc.data().dateTime.seconds,
          });
          indexData.push({
            name: "index",
            value: [dateVal, doc.data().index_value],
            date: doc.data().dateTime.seconds,
          });
        });

        indexData = indexData.reverse();
        momentumData = momentumData.reverse();
        sentiment2Data = sentiment2Data.reverse();
        sentimentData = sentimentData.reverse();

        dispatch({
          type: WEB_ACTION.DAILY_SENTIMENT,
          payload: {
            index: indexData,
            momentum: momentumData,
            sentiment2: sentiment2Data,
            sentiment: sentimentData,
            loaded: true,
            requested: true,
          },
        });
      });
  };
}

export default function DailySentiment(state = initialState, action: any) {
  switch (action.type) {
    case WEB_ACTION.DAILY_SENTIMENT:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
export const dailySentimentSelector = (state: any) => state.DailySentiment;
